<template>
	<div class="w-full" role="presentation">
		<h3 class="font-bold tracking-wide" :class="titleClass">
			{{ title ? title : 'Häufig gestellte Fragen' }}
		</h3>
		<div class="divide-y divide-grey-light">
			<div v-for="(item, index) in items" :key="index" class="accordion-item">
				<div
					v-if="
						item.title &&
						(item.description || (item[topLevelDomain] && item[topLevelDomain].description))
					"
					class="flex items-center sm:px-3 cursor-pointer"
					@click="toggleItem(index)"
				>
					<HokButton
						color="white"
						size="small"
						@click.stop="toggleItem(index)"
						@touchend.stop="toggleItem(index)"
					>
						<HokIcon
							ref="arrow-right"
							:class="{ 'rotate-90': activeItem === index }"
							name="icon:arrow-right"
							:size="buttonSize"
							class="flex-shrink-0 transition-transform mr-3 sm:mr-5 duration-300"
						/>
					</HokButton>
					<h4 class="tracking-wide mb-0" :class="descriptionClass" v-html="item.title"></h4>
				</div>
				<TransitionExpand>
					<div v-if="activeItem === index">
						<div
							class="pl-11 pr-3 sm:pl-16 sm:pr-10 pb-8"
							v-html="
								item.description || (item[topLevelDomain] && item[topLevelDomain].description)
							"
						/>
						<div v-if="item.paymentLogos" class="flex justify-center items-center text-center">
							<div
								v-for="logo in paymentLogosPricing"
								:key="logo.imgAlt"
								class="inline-block w-24 align-middle mb-4 lg:mb-0 mx-1 sm:mx-3"
							>
								<NuxtImg
									loading="lazy"
									:src="
										logo.imgSource ? `/shared-components-nuxt3/svgs/logos/${logo.imgSource}` : logo
									"
									:alt="logo.imgAlt || 'Zahlungsmittel'"
									class="inline-block align-middle max-w-[90px] max-h-[32px]"
								/>
							</div>
						</div>
					</div>
				</TransitionExpand>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { getPaymentLogos } from '../helpers/logos';
import TransitionExpand from './TransitionExpand.vue';

export default defineComponent({
	name: 'FAQ',
	components: { TransitionExpand },
	emits: ['view-answer'],
	data() {
		return {
			activeItem: -1,
			paymentLogosPricing: getPaymentLogos('pricing')
		};
	},
	computed: {
		topLevelDomain(): string {
			return this.$nuxt?.$userRootStore?.topLevelDomain || 'at';
		},
		titleClass() {
			let titleClasses: string[];
			switch (this.styling) {
				case 'small':
					titleClasses = ['mb-2'];
					break;
				default:
					titleClasses = ['text-2xl', 'mb-4'];
					break;
			}
			return titleClasses;
		},
		descriptionClass() {
			let descriptionClasses: string[];
			switch (this.styling) {
				case 'small':
					descriptionClasses = ['text-base', 'py-3'];
					break;
				default:
					descriptionClasses = ['pr-2', 'py-6'];
					break;
			}
			return descriptionClasses;
		},
		buttonSize() {
			let buttonSize: number;
			switch (this.styling) {
				case 'small':
					buttonSize = 4;
					break;
				default:
					buttonSize = 6;
					break;
			}
			return buttonSize;
		}
	},
	methods: {
		toggleItem(index: number) {
			if (this.activeItem === index) {
				this.activeItem = -1;
			} else {
				this.$emit('view-answer', index);
				this.activeItem = index;
			}
		}
	},
	props: {
		items: {
			type: Array as PropType<{ title: string; description: string; paymentLogos: any }[]>,
			default: () => []
		},
		title: { type: String, default: '' },
		styling: {
			type: String,
			default: 'default',
			validator: (value: string) => ['default', 'small'].includes(value)
		}
	}
});
</script>
